import React from "react";
import Topbar from "../../components/topbar/topbar";
import Footer from "../../components/footer/footer";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import "./index.css";
import { useTranslation } from "react-i18next";
export default function PaymentCancel() {
  const { t } = useTranslation("publicMisc");
   const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // check if current route is /payment-cancelled
    if (location.pathname === "/payment-cancelled") {
      navigate("/"); // redirect to main route
    }
  };
  return (
    <>
      <Topbar />
       <div className="thankyou-container">
      <div className="thankyou-card">
        <img
          src="/images/Union-icon.png"
          alt={t("paymentCancelled.iconAlt")}
          className="thankyou-icon"
        />

        <h2>{t("paymentCancelled.title")}
</h2>

        <p className="thankyou-text">
         {t("paymentCancelled.message")}
        </p>

        <button className="rounded-btn"  onClick={handleClick}>{t("paymentCancelled.clickHere")}</button>
      </div>
    </div>

    </>
  );
}
